module.exports = __webpack_public_path__ + "assets/img/library.69530efc.png";